import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PidRequest, SpecificData } from '../_model/pid-request';
import { PidResponseData, PreviewSpaceResponse } from '../_model/preview-space-response';
import { RequestStatusEnum } from '../_model/request-status-enum';
import { OOTSRequirements } from '../_model/oots-requirements';

const PREVIEW_API_URL = environment.api_url + "/preview";

const headers = new HttpHeaders({
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": environment.api_url,
  "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, Accept, Authorization, X-Request-With, Access-Control-Request-Method, Access-Control-Request-Headers",
  "Access-Control-Allow-Credentials": "true",
  "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT, OPTIONS, TRACE, PATCH, CONNECT",
  "Access-Control-Max-Age": "300"
});

@Injectable({
  providedIn: 'root'
})
export class PreviewService {

  constructor(private http: HttpClient) { }
  
  getRequirement(requirementId: string): Observable<OOTSRequirements> {
    return this.http.get<OOTSRequirements>(PREVIEW_API_URL + "/requirement", { params: { requirementId: requirementId } });
  }

  isValidSession(session: string): Observable<RequestStatusEnum> {
    return this.http.get<RequestStatusEnum>(PREVIEW_API_URL + "/validate", { params: { session: session } });
  }

  getRemainingTime(session: string): Observable<RequestStatusEnum> {
    return this.http.get<number>(PREVIEW_API_URL + "/getRemainingTime", { params: { session: session } });
  }

  // use /mock/evidence/pdf to get a mock pdf
  getEvidence(pidRequest: PidRequest, lang: string): Observable<any> {
    return this.http.post<any>(PREVIEW_API_URL + "/evidence/pdf", pidRequest, { headers, observe: 'response', responseType: 'text' as 'json', params: { lang: lang } })
      .pipe(
        map(this.handleResponseCodes),
        catchError(this.handleError)
      )
  }

  returnError(response: PreviewSpaceResponse): Observable<any>{
    return this.http.post<any>(PREVIEW_API_URL + "/evidence/error", response)
      .pipe(
        catchError(this.handleError)
      )
  }

  returnReject(response: PreviewSpaceResponse): Observable<any>{
    return this.http.post<any>(PREVIEW_API_URL + "/evidence/reject", response)
      .pipe(
        catchError(this.handleError)
      )
  }

  sendResponse(session: string) {
    return this.http.post<any>(PREVIEW_API_URL + "/evidence/accept?session=" + session, { headers: headers, responseType: 'text' as 'json' }).pipe(
      catchError(this.handleError)
    )
  }

  getDataByService(service: string, specificData: SpecificData|undefined): Observable<PidResponseData> {
    return this.http.post<PidResponseData>(PREVIEW_API_URL + "/evidence/data?service=" + service,  {specificData},{ headers: headers }).pipe(
      catchError(this.handleError)
    )
  }
  
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) errorMessage = error.error.message;
    else errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    console.log(errorMessage);
    return throwError(() => ({
        status: error.status,
        message: errorMessage
      }));
  }

  handleResponseCodes(response: any) {
    if (response.error instanceof ErrorEvent) return throwError(() => new Error(response.error.message));
    if (response.status === 200) return { success: true, ...response };
    const errorMessage = `Error Code: ${response.status}, Message: ${response.message}`;
    console.error(errorMessage);
    return { success: false, status: response.status };
  }
}
